export const S = {
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start" as const,
    },
    mainTitle: {
        color: "#cc0000",
        fontSize: 48,
        fontWeight: 700,
        fontStyle: "italic" as const,
        margin: "0 0 18px 0",
        fontFamily: "'JohnsonText', Georgia, serif",
    },
    displayDate: {
        color: "#1a365d",
        fontSize: 22,
        fontWeight: 700,
        paddingTop: 8,
        whiteSpace: "nowrap" as const,
    },
    columns: {
        display: "grid",
        gridTemplateColumns: "minmax(0, 1.18fr) minmax(0, 0.82fr)",
        gap: 20,
        alignItems: "start" as const,
        flex: "1 1 auto",
        alignContent: "start" as const,
        minHeight: 0,
    },
    sectionTitle: {
        backgroundColor: "#1a365d",
        color: "white",
        padding: "7px 14px",
        fontSize: 17,
        fontWeight: 700,
        // marginBottom: 8,
        display: "inline-block" as const,
    },
    list: {
        margin: "8px 0 0 0",
        paddingLeft: 26,
        fontSize: 17,
        lineHeight: 1.6,
        color: "#1a202c",
        listStyleType: "disc" as const,
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: "auto",
        paddingTop: 8,
        fontSize: 18,
    },
    loading: {
        textAlign: "center" as const,
        padding: 64,
        color: "#666",
        fontSize: 18,
    },
};
